module.exports = __webpack_public_path__ + "static/img/4.67607b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/4.png
// module id = YVFv
// module chunks = 4